import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import MetService from './met-service';
import MetServiceDetail from './met-service-detail';
import MetServiceUpdate from './met-service-update';
import MetServiceDeleteDialog from './met-service-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={MetServiceUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={MetServiceUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={MetServiceDetail} />
      <ErrorBoundaryRoute path={match.url} component={MetService} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={MetServiceDeleteDialog} />
  </>
);

export default Routes;
